@if (!newBillingDesign) {
  <p class="subheading">Payment Method</p>
  @if (paymentMethodOptions?.length > 0) {
    <div class="pad-top-20">
      <p>Saved payment methods</p>
      <ds-radio-group
        data-cy="paymentMethodOptionsRadioButtons"
        class="radio-group-container"
        [control]="'paymentMethod'"
        [parentFormGroup]="formGroup"
        [options]="paymentMethodOptions"
      >
      </ds-radio-group>
    </div>
  }
  @if (displayPaymentExpiredError) {
    <div class="row">
      <ds-error-box [messageText]="paymentExpiredErrorMessage"> </ds-error-box>
    </div>
  }
  @if (!!formGroup.get('paymentMethod').value) {
    <div class="row">
      <a (click)="editPaymentMethod()" [ngClass]="{ disabled: !authorizedToEditPaymentMethod }"
        >Edit payment method</a
      >
    </div>
  }

  @if (displayDiscountWarning) {
    <ds-warning-box [headingText]="autoPayWarningHeading" [messageText]="autoPayWarningBody">
    </ds-warning-box>
  }
  <ds-add-payment-method-quicklinks
    [authorizedToEditPaymentMethod]="authorizedToEditPaymentMethod"
    [authorizedToAddPaymentMethod]="authorizedToAddPaymentMethod"
    [displayAutoPayDiscountMessage]="true"
    [displayDiscountWarning]="displayDiscountWarning"
    [displayPaymentExpiredError]="displayPaymentExpiredError"
    [displayAutoPayDiscountMessage]="displayAutoPayDiscountMessage"
    [formGroup]="formGroup"
    [paymentMethodError]="paymentMethodError"
    [paymentMethodOptions]="paymentMethodOptions"
    (addCheckingAccountEvent)="addCheckingAccount()"
    (addCreditDebitEvent)="addCreditDebit()"
    (addSavingsAccountEvent)="addSavingsAccount()"
  >
  </ds-add-payment-method-quicklinks>
  @if (paymentMethodError) {
    <div class="row">
      <ds-error-box [messageText]="choosePaymentMethod"> </ds-error-box>
    </div>
  }
  @if (paymentError) {
    <div class="row">
      <ds-error-box data-cy="paymentErrorMessage" [messageText]="paymentError"> </ds-error-box>
    </div>
  }
}

@if (newBillingDesign) {
  <div class="header">Edit payment method</div>
  @if (paymentMethodOptions?.length > 0) {
    <div class="pad-top-20">
      <div class="flex sub-header">
        <span>Saved payment methods</span>
        <span class="add-btn" (click)="addPaymentMethod()">
          <img src="/assets/images/plus.svg" />Add</span
        >
      </div>
      <ds-radio-group
        data-cy="paymentMethodOptionsRadioButtons"
        class="radio-group-container"
        [control]="'paymentMethod'"
        [parentFormGroup]="formGroup"
        [options]="paymentMethodOptions"
        [haveAction]="true"
        [actionName]="'Edit'"
        (actionEvent)="editPaymentMethodOption($event)"
        [newBillingDesign]="true"
      >
      </ds-radio-group>
    </div>
  } @else {
    <div class="add-pay-method" (click)="addPaymentMethod()">
      <img class="margin-right-16" src="/assets/images/plus.svg" />
      <span
        class="font-size-1 font-weight-semibold"
        dsContent
        [contentPath]="'billing.addPayMethod'"
        >Add payment method</span
      >
    </div>
  }
  @if (displayPaymentExpiredError) {
    <div class="row">
      <ds-error-box [messageText]="paymentExpiredErrorMessage"> </ds-error-box>
    </div>
  }
}

<ds-modal
  id="autopayAddModalId"
  class="paymentModal"
  [closeOthers]="true"
  [maxWidth]="450"
  [fullScreen]="true"
  [defaultCloseButton]="true"
>
  <ds-add-payment-method-quicklinks
    [authorizedToEditPaymentMethod]="authorizedToEditPaymentMethod"
    [authorizedToAddPaymentMethod]="authorizedToAddPaymentMethod"
    [displayAutoPayDiscountMessage]="true"
    [displayDiscountWarning]="displayDiscountWarning"
    [displayPaymentExpiredError]="displayPaymentExpiredError"
    [displayAutoPayDiscountMessage]="displayAutoPayDiscountMessage"
    [formGroup]="formGroup"
    [paymentMethodError]="paymentMethodError"
    [paymentMethodOptions]="paymentMethodOptions"
    (addCheckingAccountEvent)="addCheckingAccount()"
    (addCreditDebitEvent)="addCreditDebit()"
    (addSavingsAccountEvent)="addSavingsAccount()"
    [newBillingDesign]="true"
  >
  </ds-add-payment-method-quicklinks>
</ds-modal>
